import type { Difficulty } from "@prisma/client";

export const UPLOAD_BASE_URL = "https://img.knoword.com"; // TODO: change this

export const MAX_FREE_PACKS = 5;
export const MAX_FREE_ASSIGNMENTS = 2;
export const MAX_PROMPT_LENGTH = 300;
export const MAX_AUDIO_DURATION = 60; // seconds

export const FREE_PLAN_NAME = "Basic";

export const PRO_PRODUCT_ID = import.meta.env.PROD
  ? "prod_FSJwnf5TCnoWsb"
  : "prod_F5k6UTTtl6BaV4";

export const TEAM_PRODUCT_ID = import.meta.env.PROD
  ? "prod_IMw3kohs2mIiQR"
  : "prod_II1JJnc67ieIl7";

export const PACKS_PAGE_SIZE = 12;
export const COLLECTIONS_PAGE_SIZE = 24;

export const MAILJET_NEWSLETTER_LIST_ID = 10319145;
export const MAILJET_TEACHERS_LIST_ID = 10516491;

export const TIME_LIMIT_MIN = 30;
export const TIME_LIMIT_MAX = 300;
export const TIME_LIMIT_STEP = 30;
export const DEFAULT_TIME_LIMIT = 90;

export const DIFFICULTIES = [
  "junior",
  "basic",
  "intermediate",
  "advanced",
  "expert",
] as const satisfies Difficulty[];
